import { useLocalization } from "../egencia-provider/index.js";
import * as React from "react";
import { classNames, Level, liveAnnounce } from "../uitk-react-utils/index.js";
import { UitkLoader } from "./uitk-loader.js";
export function UitkPageLoader({
  visible,
  title,
  className,
  style
}) {
  const l10n = useLocalization();
  const titleOrI10n = title || l10n.formatText("loading");
  const baseCssClass = "uitk-loader-page";
  const cssClassNames = classNames(baseCssClass, className, {
    "is-visible": visible
  });
  if (visible) {
    liveAnnounce(title, Level.POLITE);
  }
  return /* @__PURE__ */ React.createElement(
    UitkLoader,
    {
      className: cssClassNames,
      title: titleOrI10n,
      "aria-hidden": !visible,
      style
    }
  );
}
